import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import HighlightsSection from "./HighlightsSection";
import ProjectsSection from "./ProjectsSection";
import ExperienceSection from "./ExperienceSection";
import ContactSection from "./ContactSection";
import { useApiCall } from "../../util/ApiCall";

export default function HomePage() {
  const { refreshToken } = useApiCall();

  useEffect(() => {
    refreshToken({ forceSign: false });
  }, [refreshToken]);

  return (
    <>
      <HeroSection />
      <HighlightsSection />
      <ProjectsSection />
      <ExperienceSection />
      <ContactSection />
    </>
  );
}
